import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

/** Vista di stato condivisa (V61): un messaggio e una via d'uscita. */
export function VistaStato({
  titolo,
  children,
  uscita,
}: {
  titolo: string;
  children: ReactNode;
  uscita: { a: string; etichetta: string };
}) {
  return (
    <div className="max-w-md px-4 pt-[max(24px,env(safe-area-inset-top))] pb-6">
      <h1 className="mb-2 text-[22px] font-bold">{titolo}</h1>
      <p className="mb-4 text-muted-foreground">{children}</p>
      <Button asChild variant="outline">
        <Link to={uscita.a}>{uscita.etichetta}</Link>
      </Button>
    </div>
  );
}

/**
 * Vista 404. Il testo e lo stesso per una risorsa inesistente e per una di
 * un'altra societa: distinguerli rivelerebbe l'esistenza di dati altrui.
 */
export function NonTrovata() {
  return (
    <VistaStato titolo="Pagina non trovata" uscita={{ a: '/', etichetta: "Torna all'inizio" }}>
      La pagina non esiste o non è accessibile con il tuo account.
    </VistaStato>
  );
}
